import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { TextField, Button, Box, Typography } from "@mui/material";
import { useFormik } from "formik";
import { loginSchema } from "../utils/validation";
import { useAuth } from "../context/AuthProvider";
// import CustomIcon from "../icons/CustomIcon";
import { Link } from "react-router-dom";
import { axiosInstance } from "../service/axiosInstance";
import serviceEndpoints from "../services/serviceEndpoints";

const Login = () => {
  const { loginFn, userDetail, setIsLoading } = useAuth();

  const navigate = useNavigate();

  const { handleSubmit, handleChange, touched, errors, isSubmitting } =
    useFormik({
      initialValues: {
        email: "",
        password: "",
      },
      onSubmit: (value) => handleLogin(value),
      validationSchema: loginSchema,
    });

  async function handleLogin(value) {
    setIsLoading(true);
    try {
      let res = await axiosInstance.post(serviceEndpoints.loginEndpoints, {
        ...value,
      });
      console.log("response of login", res);
      loginFn(res);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (userDetail?.data?.accessToken) {
      navigate("/handle-meetings");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetail]);

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <Box
        sx={{
          width: "100%",
          maxWidth: 360,
        }}
      >
        {/* <Typography
          variant="h6"
          sx={{
            mb: 3,
            textAlign: "center",
            fontSize: "25px",
          }}
          className="typography_heading"
        >
          <span style={{ position: "relative", top: "-5px" }}>
            <CustomIcon color={"var(--aqua-9)"} />
          </span>
          Zuno Staar
        </Typography> */}
        <Typography
          variant="h6"
          sx={{
            mb: 3,
            textAlign: "center",
          }}
          className="typography_heading"
        >
          <img
            src="/icons/STAAR logo_Final_2025-01 .png"
            alt="Zuno Staar Logo"
            style={{
              height: "150px",
              marginRight: "8px",
              verticalAlign: "middle",
            }}
          />
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Email"
            name="email"
            variant="outlined"
            onChange={handleChange}
            error={touched.email && errors.email}
            helperText={touched.email && errors.email}
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            variant="outlined"
            margin="normal"
            name="password"
            error={touched.password && errors.password}
            helperText={touched.password && errors.password}
            onChange={handleChange}
          />

          <Typography
            variant="body2"
            sx={{ mt: 1, mb: 2, color: "#030303ff;", textAlign: "right" }}
          >
            <Link
              to="/forgot-password"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              Forgot password?
            </Link>
          </Typography>
          <Button
            fullWidth
            type="submit"
            variant="contained"
            disabled={isSubmitting}
          >
            Log in
          </Button>
        </form>
      </Box>
    </div>
  );
};

export default Login;
